import { createModel } from '@/store/tools';

const model = {
    namespace: 'insuranceorder',
    build: (T, A, S, R, C) => ({
        actiontypes: {
            'getVirtualNoRecords': T('getVirtualNoRecords'),
            'getInsurePolicyList': T('getInsurePolicyList'),
        },
        actions: {
            'getVirtualNoRecords': A('getVirtualNoRecords'),
        },
        sagas: {
            'getVirtualNoRecords': S('getVirtualNoRecords', '/?cmd=com.xqxc.api.pig.mis.order.DeliveryContactRecordService.getDeliveryContactRecordList'),
        },
        reducers: {
            'virtualNoRecords': R('getVirtualNoRecords', { dataList: [], pageNum: 1, pageSize: 30, resultTotal: 0 }),
        }
    })
};
export default createModel(model);